export const PlanPerformanceTabsOptions = [
  { label: 'Overview', value: 0 },
  { label: 'Learning Plans ', value: 1, isDisabled: true },
  { label: 'Capabilities', value: 2 },
];
